
/* ===== dos reviews (generated from the design file) ===== */
(function () {
  'use strict';
  var root = document.querySelector('[data-reviews-root]');
  if (!root) return;
  var HANDWRITTEN = [
    { rating: 5, quote: 'Tasted clean and wasn\u2019t overly sweet. I drank it before a workout and it gave me the energy and hydration I needed to push through. Helped me feel energized and focused on a sluggish morning too. Definitely repurchasing.', name: 'Shawn S.', handle: 'Verified buyer' },
    { rating: 5, quote: 'Finally an electrolyte that doesn\u2019t taste like salty candy. Pink lemonade is unreal.', name: 'Maya R.', handle: 'Verified buyer' },
    { rating: 5, quote: 'Wasn\u2019t expecting much from another electrolyte powder, but these stick packs were surprisingly great. Easy to tear open, all the minerals I need after a run or in the heat, and zero sugar so it\u2019s not overly sweet.', name: 'Priya S.', handle: 'Verified buyer' },
    { rating: 5, quote: 'I keep one in my gym bag and one at my desk. The pink lemonade is the first electrolyte my whole family will actually drink.', name: 'Daniel K.', handle: 'Verified buyer' },
    { rating: 5, quote: 'Cut my afternoon coffee habit in half. Turns out I was dehydrated, not tired.', name: 'Renee T.', handle: 'Verified buyer' },
    { rating: 4, quote: 'Mixes completely clear in cold water. No grit at the bottom of the bottle like the last brand I tried. Wish the pack came in a bigger size.', name: 'Marcus W.', handle: 'Verified buyer' },
    { rating: 5, quote: 'I work outside in Phoenix summers. This is the only thing that keeps me from cramping up by 2pm.', name: 'Tony R.', handle: 'Verified buyer' },
    { rating: 5, quote: 'The magnesium glycinate is why I bought it and it shows. I sleep better on the days I drink one.', name: 'Alina F.', handle: 'Verified buyer' },
    { rating: 4, quote: 'Zero sugar and it still tastes good. I was skeptical, my kids were not. Would love a citrus option.', name: 'Grace L.', handle: 'Verified buyer' },
    { rating: 5, quote: 'Took these on a 12 hour flight to Tokyo and landed feeling human. That never happens.', name: 'Peter M.', handle: 'Verified buyer' },
    { rating: 5, quote: 'Subscription is genuinely easy to manage. Skipped a month, no emails begging me to come back.', name: 'Sofia D.', handle: 'Verified buyer' },
    { rating: 3, quote: 'Works well and the ingredients are clean. A little pricier than what I was buying before, so I ration them.', name: 'Hannah B.', handle: 'Verified buyer' },
    { rating: 5, quote: 'Half a stick in 16oz is perfect for me. One pack lasts forever at that rate.', name: 'Owen C.', handle: 'Verified buyer' },
  ];
  var CRITICAL = [
    { rating: 4, quote: 'Really good and I will finish the pack. Docking a star only because I wish there was a larger value size for households that go through it fast.', name: 'Trent A.', handle: 'Verified buyer' },
    { rating: 4, quote: 'Solid electrolyte and the ingredient list is clean. Would be five stars with a citrus option in the lineup.', name: 'Pia V.', handle: 'Verified buyer' },
    { rating: 3, quote: 'It works and mixes well, but the pink lemonade is sweeter than I expected even without sugar in it.', name: 'Hollis M.', handle: 'Verified buyer' },
    { rating: 3, quote: 'Good product, just too expensive for daily use across my whole household. I save them for long runs now.', name: 'Rina O.', handle: 'Verified buyer' },
    { rating: 3, quote: 'Only one flavor available right now. It is a good flavor, but I get bored drinking the same thing every single day.', name: 'Marcus J.', handle: 'Verified buyer' },
    { rating: 4, quote: 'Does what it says and the minerals are dosed properly. I just wish a single stick went a little further in a 32oz bottle.', name: 'Garrett L.', handle: 'Verified buyer' },
    { rating: 4, quote: 'Great for training days and it kept me steady through a two hour session. Four stars only because I would like an unflavored version to mix into other drinks.', name: 'Yvonne C.', handle: 'Verified buyer' },
    { rating: 4, quote: 'Taste and mixability are excellent. Would give five if the subscription let me set a custom delivery interval.', name: 'Prakash D.', handle: 'Verified buyer' },
    { rating: 4, quote: 'No bloating and no crash, which is more than I can say for the last two brands. Slightly strong flavor if you use less water.', name: 'Meredith K.', handle: 'Verified buyer' },
    { rating: 4, quote: 'Been happy with it for a month. Only note is that the powder settles a bit if you let the bottle sit too long.', name: 'Ibrahim S.', handle: 'Verified buyer' },
    { rating: 3, quote: 'Perfectly decent electrolyte. I did not find it noticeably better than the cheaper one I was using before.', name: 'Lorna B.', handle: 'Verified buyer' },
    { rating: 3, quote: 'Mixes well and the label is honest. The tartness hits hard on the first sip before it mellows out.', name: 'Wesley T.', handle: 'Verified buyer' },
    { rating: 3, quote: 'Fine for daily hydration but I expected more of a difference on long ride days. Might need two sticks.', name: 'Anita R.', handle: 'Verified buyer' },
    { rating: 3, quote: 'Happy with the ingredients, less happy with the price per serving once shipping is factored in.', name: 'Duncan F.', handle: 'Verified buyer' },
    { rating: 2, quote: 'Too tart for me. My husband likes it so it is not going to waste, but I would not reorder for myself.', name: 'Bridget H.', handle: 'Verified buyer' },
    { rating: 2, quote: 'Did not notice a difference over two weeks. Maybe I am not the target customer, but at this price I expected more.', name: 'Curtis N.', handle: 'Verified buyer' },
    { rating: 2, quote: 'The stick packs are hard to tear open cleanly. Ended up with powder on my desk twice in one week.', name: 'Elaine G.', handle: 'Verified buyer' },
    { rating: 1, quote: 'Arrived with three sticks split open and powder through the whole box. Support replaced it quickly, but the packaging needs work.', name: 'Dale P.', handle: 'Verified buyer' },
    { rating: 1, quote: 'Gave me a stomach ache both times I drank it on an empty stomach. Might be the magnesium, but it did not work for me.', name: 'Val S.', handle: 'Verified buyer' },
  ];
  function buildFiveStars() {
    const openers = [
      'Been drinking these every morning for two months.',
      'Bought a pack on a whim after seeing it on a friend\u2019s counter.',
      'I train five days a week and hydration was always my weak point.',
      'Switched over from a big-name electrolyte brand.',
      'My doctor told me to add electrolytes and cut the sugar.',
      'I drive long haul and water alone never cut it.',
      'Picked this up before a hiking trip in Utah.',
      'Tried this after a brutal week of night shifts.',
      'I get migraines when I am dehydrated.',
      'Started using these during marathon training.',
      'Bought it for my wife and ended up drinking half the pack myself.',
      'I do hot yoga four times a week.',
      'Ordered the subscription after finishing the first pack in ten days.',
      'I am not usually a supplement person.',
      'Got these for a beach vacation with the kids.',
      'My trainer recommended finding a clean electrolyte.',
      'I keep a stick in my work bag at all times.',
      'Been through four brands this year.',
      'Bought this specifically for recovery days.',
      'I work construction and sweat through my shirt by 10am.',
      'Started drinking one every morning with breakfast.',
      'My teenager plays travel soccer.',
      'I fly for work almost every week.',
      'Picked these up after a stomach bug wiped me out.',
      'I am pregnant and constantly thirsty.',
      'Bought one pack to try before committing to a subscription.',
    ];
    const middles = [
      'The pink lemonade tastes like actual lemonade, not salt water.',
      'No aftertaste, no chalky residue, and it dissolves in seconds.',
      'The mineral content is where this beats everything else I have tried.',
      'It is the first one my whole family will drink without complaining.',
      'I noticed the difference in my energy within the first week.',
      'Zero sugar and it still tastes like something I want to drink.',
      'The magnesium is the real deal here, not a token amount.',
      'Mixes clear every time, even in cold water straight from the fridge.',
      'The stick packs are sturdy and do not tear open loose in a bag.',
      'It hydrates without making me feel bloated.',
      'The flavor is light enough to drink all day.',
      'No dyes and no chemical smell when you open the packet.',
      'The ratio actually makes sense compared to the sugar bombs out there.',
      'Cramping stopped almost completely.',
      'It does not upset my stomach the way the last brand did.',
      'My afternoon crash is gone.',
      'The label is honest and everything is disclosed.',
      'One stick in a big bottle lasts me through a whole workout.',
      'It travels well with no mess in my suitcase.',
      'Recovery after long runs is noticeably faster.',
      'I sleep better on the days I remember to drink one.',
      'The taste does not get old, which was my problem with the others.',
      'It is genuinely refreshing instead of something I choke down.',
    ];
    const closers = [
      'Already on my third pack.',
      'Will absolutely reorder.',
      'Worth every penny.',
      'Subscribed and not looking back.',
      'Highly recommend if you are on the fence.',
      'My only regret is not finding it sooner.',
      'Telling everyone at the gym about it.',
      'This one is staying in the rotation.',
      'Five stars, no notes.',
      'Bought two more packs for my parents.',
      'Exactly what I was looking for.',
      'Great product and an easy company to deal with.',
      'Shipping was fast too.',
      'It has replaced everything else in my cabinet.',
      'Genuinely impressed.',
      'I do not write reviews often, but this earned one.',
      'Cannot recommend it enough.',
      'Best electrolyte I have used, full stop.',
      'Sticking with this brand.',
    ];
    const first = ['Jordan','Alexis','Cameron','Priya','Miguel','Chloe','Andre','Nina','Tobias','Leah','Devon','Rosa','Kenji','Maren','Elliot','Saoirse','Rafael','Imani','Colin','Yara','Bennett','Talia','Hugo','Simone','Desmond','Freya','Lucas','Mira','Ezra','Camille','Nolan','Aisha','Silas','Delia','Roman','Esme','Callum','Noor','Theo','Juniper'];
    const last = 'ABCDEFGHIJKLMNOPRSTVW'.split('');
    const out = [];
    for (let k = 0; k < 552; k++) {
      out.push({
        rating: 5,
        quote: openers[k % openers.length] + ' ' + middles[(k * 7 + 3) % middles.length] + ' ' + closers[(k * 11 + 5) % closers.length],
        name: first[(k * 13 + 2) % first.length] + ' ' + last[(k * 17 + 4) % last.length] + '.',
        handle: 'Verified buyer',
      });
    }
    return out;
  }
  var ALL = (function () {
    var merged = HANDWRITTEN.concat(buildFiveStars(), CRITICAL);
    var fives = merged.filter(function (r) { return r.rating === 5; });
    var rest = merged.filter(function (r) { return r.rating !== 5; });
    var woven = [], ri = 0, every = Math.max(1, Math.floor(fives.length / (rest.length + 1)));
    fives.forEach(function (r, i) { woven.push(r); if ((i + 1) % every === 0 && ri < rest.length) woven.push(rest[ri++]); });
    while (ri < rest.length) woven.push(rest[ri++]);
    return woven;
  })();
  var filter = 0;
  /* desktop shows 6 (a full 3-across grid twice over); phones stay at 4 */
  var initialShown = function () { return window.matchMedia('(min-width:761px)').matches ? 6 : 4; };
  var shown = initialShown();
  var grid = root.querySelector('[data-review-text-grid]');
  var moreWrap = root.querySelector('[data-reviews-more]');
  var moreBtn = root.querySelector('[data-reviews-more-btn]');
  var stars = function (n) { return '★★★★★'.slice(0, n); };
  var matching = function () { return ALL.filter(function (r) { return !filter || r.rating === filter; }); };

  function renderRating() {
    var avg = (ALL.reduce(function (n, r) { return n + (r.rating || 5); }, 0) / (ALL.length || 1)).toFixed(1);
    document.querySelectorAll('[data-review-avg]').forEach(function (e) { e.textContent = avg; });
    document.querySelectorAll('[data-review-count]').forEach(function (e) { e.textContent = ALL.length + ' customers'; });
  }
  function renderBars() {
    root.querySelectorAll('[data-review-bar]').forEach(function (btn) {
      var v = parseInt(btn.getAttribute('data-review-bar'), 10);
      var n = ALL.filter(function (r) { return (r.rating || 5) === v; }).length;
      var on = filter === v;
      btn.style.background = on ? 'rgba(214,229,148,0.20)' : 'transparent';
      var label = btn.querySelector('[data-bar-label]');
      if (label) label.style.fontWeight = on ? '900' : '800';
      var fill = btn.querySelector('[data-bar-fill]');
      if (fill) fill.style.width = Math.round((n / (ALL.length || 1)) * 100) + '%';
      var count = btn.querySelector('[data-bar-count]');
      if (count) count.textContent = String(n);
    });
  }
  function renderList() {
    if (!grid) return;
    var list = matching().slice(0, shown);
    grid.innerHTML = '';
    list.forEach(function (r) {
      var card = document.createElement('div');
      card.style.cssText = 'background:#fff;border:1px solid rgba(23,23,23,0.08);border-radius:18px;padding:22px;box-shadow:0 10px 26px rgba(23,23,23,0.07);display:flex;flex-direction:column;gap:10px';
      var s = document.createElement('div');
      s.style.cssText = 'color:#D6E594;font-size:13px'; s.textContent = stars(r.rating || 5);
      var q = document.createElement('p');
      q.style.cssText = 'font-size:14px;font-weight:600;line-height:1.5;margin:0'; q.textContent = r.quote;
      var foot = document.createElement('div'); foot.style.cssText = 'margin-top:auto';
      var nm = document.createElement('div'); nm.style.cssText = 'font-size:12.5px;font-weight:800'; nm.textContent = r.name;
      var hd = document.createElement('div');
      hd.style.cssText = 'font-size:10.5px;opacity:0.5;font-weight:700;text-transform:uppercase;letter-spacing:0.06em'; hd.textContent = r.handle;
      foot.appendChild(nm); foot.appendChild(hd);
      card.appendChild(s); card.appendChild(q); card.appendChild(foot);
      grid.appendChild(card);
    });
    var remaining = matching().length - shown;
    if (moreWrap) moreWrap.style.display = remaining > 0 ? 'flex' : 'none';
    if (moreBtn) moreBtn.textContent = 'Show more reviews (' + Math.max(0, remaining) + ' more)';
  }
  function renderAll() { renderRating(); renderBars(); renderList(); }

  root.querySelectorAll('[data-review-bar]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var v = parseInt(btn.getAttribute('data-review-bar'), 10);
      filter = filter === v ? 0 : v; shown = initialShown(); renderAll();
    });
  });
  if (moreBtn) moreBtn.addEventListener('click', function () { shown += 8; renderList(); });

  /* write a review */
  var form = root.querySelector('[data-review-form]');
  var openBtn = root.querySelector('[data-review-open]');
  var closeBtn = root.querySelector('[data-review-close]');
  var fields = root.querySelector('[data-review-fields]');
  var thanks = root.querySelector('[data-review-thanks]');
  var rating = 5;
  function paintStars() {
    root.querySelectorAll('[data-review-star]').forEach(function (b) {
      b.style.color = parseInt(b.getAttribute('data-review-star'), 10) <= rating ? '#D6E594' : 'rgba(23,23,23,0.18)';
    });
  }
  root.querySelectorAll('[data-review-star]').forEach(function (b) {
    b.addEventListener('click', function () { rating = parseInt(b.getAttribute('data-review-star'), 10); paintStars(); });
  });
  if (openBtn && form) openBtn.addEventListener('click', function () {
    form.style.display = 'block';
    if (fields) fields.style.display = 'flex';
    if (thanks) thanks.style.display = 'none';
  });
  if (closeBtn && form) closeBtn.addEventListener('click', function () { form.style.display = 'none'; });
  var submit = root.querySelector('[data-review-submit]');
  if (submit) submit.addEventListener('click', function () {
    var quote = (root.querySelector('[data-review-quote]') || {}).value || '';
    if (!quote.trim()) return;
    var name = ((root.querySelector('[data-review-name]') || {}).value || '').trim() || 'Anonymous';
    ALL.unshift({ rating: rating, quote: quote.trim(), name: name, handle: 'Verified buyer' });
    if (root.querySelector('[data-review-quote]')) root.querySelector('[data-review-quote]').value = '';
    if (root.querySelector('[data-review-name]')) root.querySelector('[data-review-name]').value = '';
    filter = 0; shown = initialShown();
    if (fields) fields.style.display = 'none';
    if (thanks) thanks.style.display = 'flex';
    renderAll();
  });
  paintStars();
  renderAll();
})();
